import React, { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useAppSelector } from '../../redux/store';
import { useTranslation } from 'react-i18next';
import { getLanguageDirection } from '../../i18n/config';

interface ProtectedRouteProps {
  redirectPath?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  redirectPath = '/login'
}) => {
  const { isAuthenticated: contextAuthenticated, loading } = useAuth();
  const { isAuthenticated: reduxAuthenticated } = useAppSelector(state => state.UserReducer);
  const { t, i18n } = useTranslation();
  const isRTL = getLanguageDirection(i18n.language) === 'rtl';
  
  // Use either context or Redux authentication state
  const isAuthenticated = contextAuthenticated || reduxAuthenticated;
  
  console.log('ProtectedRoute - contextAuthenticated:', contextAuthenticated, 
              'reduxAuthenticated:', reduxAuthenticated, 
              'isAuthenticated:', isAuthenticated);

  // Loading state
  if (loading) {
    return <div>{t('common.auth.loading')}</div>;
  }

  if (!isAuthenticated) {
    console.log('ProtectedRoute - not authenticated, redirecting to', redirectPath);
    return <Navigate to={redirectPath} replace />;
  }

  console.log('ProtectedRoute - authenticated, rendering outlet');
  return (
    <div 
      dir={getLanguageDirection(i18n.language)}
      style={{ direction: getLanguageDirection(i18n.language) }}
    >
      <Outlet />
    </div>
  );
};

export default ProtectedRoute; 
